export default "__VITE_ASSET__BXmED2nV__"